const routes = {
  home: {
    path: '/',
    title: 'Báthory István DSE',
    navbar: false
  },
  about: {
    path: '/about',
    title: 'Rólunk',
    navbar: true,
    children: {
      atletika: {
        path: '/about/atletika',
        title: 'Atlétika szakosztályról'
      },
      kezilabda: {
        path: '/about/kezilabda',
        title: 'Kézilabda szakosztályról'
      },
      labdarugas: {
        path: '/about/labdarugas',
        title: 'Labdarúgó szakosztályról'
      },
      roplabda: {
        path: '/about/roplabda',
        title: 'Röplabda szakosztályról'
      },
      tollaslabda: {
        path: '/about/tollaslabda',
        title: 'Tollaslabda szakosztályról'
      },
      uszas: {
        path: '/about/uszas',
        title: 'Báthory Vízi sportkörről'
      }
    }
  },
  documents: {
    path: '/docs',
    title: 'Dokumentumok',
    navbar: true,
    children: {
      atletika: {
        path: '/docs/atletika',
        title: 'Atlétika szakosztály dokumentumai'
      },
      kezilabda: {
        path: '/docs/kezilabda',
        title: 'Kézilabda szakosztály dokumentumai'
      },
      labdarugas: {
        path: '/docs/labdarugas',
        title: 'Labdarúgó szakosztály dokumentumai'
      },
      roplabda: {
        path: '/docs/roplabda',
        title: 'Röplabda szakosztály dokumentumai'
      },
      tollaslabda: {
        path: '/docs/tollaslabda',
        title: 'Rollaslabda szakosztály dokumentumai'
      },
      uszas: {
        path: '/docs/uszas',
        title: 'Báthory Vízi sportkör dokumentumai'
      }
    }
  },
  news: {
    path: '/news',
    title: 'Hírek',
    navbar: true,
    children: {
      specificNews: {
        path: '/news/:id',
        title: 'Hírek'
      }
    }
  },
  archive: {
    path: '/archive',
    title: 'Archívum',
    navbar: true
  },
  gallery: {
    path: '/gallery',
    title: 'Galéria',
    navbar: true,
    children: {
      atletika: {
        path: '/gallery/atletika',
        title: 'Képek az tlétika szakosztályról'
      },
      kezilabda: {
        path: '/gallery/kezilabda',
        title: 'Képek a kézilabda szakosztályról'
      },
      labdarugas: {
        path: '/gallery/labdarugas',
        title: 'Képek a labdarúgó szakosztályról'
      },
      roplabda: {
        path: '/gallery/roplabda',
        title: 'Képek a röplabda szakosztályról'
      },
      tollaslabda: {
        path: '/gallery/tollaslabda',
        title: 'Képek a rollaslabda szakosztályról'
      },
      uszas: {
        path: '/gallery/uszas',
        title: 'Képek a Báthory Vízi sportkörről'
      }
    }
  },
  contact: {
    path: '/contact',
    title: 'Kapcsolat',
    navbar: true
  },
  login: {
    path: '/login',
    title: 'Bejelentkezés',
    navbar: false
  },
  admin: {
    path: '/admin',
    title: 'Rendszergazdai felület',
    navbar: false,
    children: {
      uploadNews: {
        path: '/admin/news/upload',
        title: 'Új hír feltöltése - Admin'
      },
      editNews: {
        path: '/admin/news/edit/:id',
        title: 'Hír szerkesztése - Admin'
      }
    }
  }
} as const;

export default routes;
